import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, IJobType, registerJob } from './jobs'
import { createTask_moveTo } from './taskMoveTo'
import { createTask_unstackCargo } from './taskUnstackCargo'

const jobType: IJobType = 'unstack'
export const register = () => registerJob(jobType, runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, jobType)

  let st = jobLogger.assertStack(job)
  jobLogger.assertNotNil(job.targetCargo)
  let ca = job.targetCargo

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []

    let task = createTask_moveTo(st.i, st.j, true, true)
    job.tasks.push(task)

    task = createTask_unstackCargo(st.i, st.j, ca)
    job.tasks.push(task)
    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
